import { AuthenticatedUser } from "@iventis/domain-model/model/authenticatedUser";

/** First letter of the user's first name, falling back to their email when they have no first name */
export const getUserInitial = (user: Pick<AuthenticatedUser, "firstName" | "emailAddress"> | null | undefined) =>
    (user?.firstName?.charAt(0) || user?.emailAddress?.charAt(0) || "").toUpperCase();
